import { CalendarOptions } from "@fullcalendar/core";
import { format } from "date-fns";
import React from "react";
import { Colors } from "src/types";
import { Input } from "./../input";
import { InputGroup, InputLabel } from "..";
import { DatePickerModal } from "./datePickerModal";
import styled, { css } from "styled-components";
import { theme } from "src/config";

interface IDatePickerProps {
  calendarProps?:   CalendarOptions,
  color?:           Colors | string,
  disabled?:        boolean,
  label?:           string,
  value?:           Date,
  start?:           Date,
  end?:             Date,
  variant?:         "underlined" | "default",
  range?:           boolean,
  showClearButton?: boolean,
  onChange?:      (value?: Date) => void,
  onRangeChange?: (start: Date, end: Date) => void,
}
export const DatePicker = (props: IDatePickerProps): JSX.Element => {
  const { showClearButton, range, variant, value, onChange, start, end, onRangeChange, calendarProps, label, disabled } = props;
  const [showCalendar, setShowCalendar] = React.useState(false);
  const formattedDate = value && format(value, "yyyy-MM-dd");
  const f_start = start ? format(start, "yyyy-MM-dd") : "";
  const f_end   = end   ? format(end, "yyyy-MM-dd") : "";

  const text = range ? 
    f_start + " - " + f_end 
    : (value ? formattedDate : undefined);

  return (
    <>
      <InputGroup>
        <InputLabel focused={showCalendar||Boolean(value)}>{label}</InputLabel>
        <StyledTextInput
          variant  = {variant}
          value    = {text}
          icons    = {range ? null : [{ iconId: "calendar", action: () => setShowCalendar(true)}]}
          onClick  = {() => setShowCalendar(true)}
          disabled = {disabled}
        />
      </InputGroup>
      <DatePickerModal 
        calendarProps   = {calendarProps}
        end             = {end}
        onClose         = {() => setShowCalendar(false)}
        onSubmit        = {onChange}
        onSubmitRange   = {onRangeChange}
        show            = {showCalendar}
        showClearButton = {showClearButton}
        start           = {start}
        value           = {value}
        range           = {range}
      />
    </>
  );
};

const StyledTextInput = styled<any>(Input)`
  ${props => props.variant==="underlined" && css`
    border:        0;
    border-bottom: 1px solid;
    border-radius: 0;
    border-color:  ${theme.color.input.border};
    padding:       0.5rem;
    padding-left:  1rem;
    max-width:     13rem;
    text-align:    center;
  `}
`;